import React from "react";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import { encStorage } from "../hooks/encStorage";
import { GET_FINANCIALS } from "../services/Apis";
import axios from "axios";
import { useEffect, useState } from "react";

const Marginrules = () => {
  const [SidebarState, setSidebarState] = useState(false);

  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const user = {
    id: encStorage.getItem("id"),
    name: encStorage.getItem("name"),
    client_code: encStorage.getItem("client_code"),
    id: encStorage.getItem("id"),
  };
  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content">
          <div className="container mt-3">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <h2 className="text-center mb-3 text-primary">Margin Rules</h2>
                <div className="card shadow border-0">
                  <div className="card-body p-2">
                    <img
                      src="/images/margin-rules-1.jpg"
                      className="w-100"
                      alt="Margin Rules 1"
                    />
                  </div>
                </div>
                <div className="card shadow border-0 mt-1">
                  <div className="card-body p-2">
                    <img
                      src="/images/margin-rules-2.jpg"
                      className="w-100"
                      alt="Margin Rules 2"
                    />
                  </div>
                </div>
                <div className="card shadow border-0 mt-1">
                  <div className="card-body p-2">
                    <img
                      src="/images/margin-rules-3.jpg"
                      className="w-100"
                      alt="Margin Rules 3"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Marginrules;
